// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e908706f","396":"cf6d9725","455":"01b5dd6c","488":"2ba1deb6","977":"9b1aabc8"}[chunkId] + ".chunk.js";
};